export const INDUSTRIES = [
    { value: 'automotive', label: 'Automotive' },
    { value: 'aviation', label: 'Aviation' },
    { value: 'insurance', label: 'Insurance' },
    { value: 'field_services', label: 'Field Services' },
    { value: 'general', label: 'General' }
];
export const IDENTIFIER_FORMATS = [
    { value: 'vin', label: 'VIN' },
    { value: 'license_plate', label: 'License Plate' },
    { value: 'odometer', label: 'Odometer' },
    { value: 'serial_number', label: 'Serial Number' },
    { value: 'aircraft_tail_number', label: 'Aircraft Tail Number' },
    { value: 'asset_tag', label: 'Asset Tag' },
    { value: 'shipping_tracking_number', label: 'Shipping Tracking Number' },
    { value: 'other', label: 'Other' }
];
// All 56 US license-plate issuing jurisdictions: 50 states + DC + 5 territories
// (Puerto Rico, Guam, US Virgin Islands, American Samoa, Northern Mariana Islands).
export const US_LICENSE_PLATE_REGIONS = [
    { value: 'AL', label: 'Alabama' },
    { value: 'AK', label: 'Alaska' },
    { value: 'AZ', label: 'Arizona' },
    { value: 'AR', label: 'Arkansas' },
    { value: 'CA', label: 'California' },
    { value: 'CO', label: 'Colorado' },
    { value: 'CT', label: 'Connecticut' },
    { value: 'DE', label: 'Delaware' },
    { value: 'FL', label: 'Florida' },
    { value: 'GA', label: 'Georgia' },
    { value: 'HI', label: 'Hawaii' },
    { value: 'ID', label: 'Idaho' },
    { value: 'IL', label: 'Illinois' },
    { value: 'IN', label: 'Indiana' },
    { value: 'IA', label: 'Iowa' },
    { value: 'KS', label: 'Kansas' },
    { value: 'KY', label: 'Kentucky' },
    { value: 'LA', label: 'Louisiana' },
    { value: 'ME', label: 'Maine' },
    { value: 'MD', label: 'Maryland' },
    { value: 'MA', label: 'Massachusetts' },
    { value: 'MI', label: 'Michigan' },
    { value: 'MN', label: 'Minnesota' },
    { value: 'MS', label: 'Mississippi' },
    { value: 'MO', label: 'Missouri' },
    { value: 'MT', label: 'Montana' },
    { value: 'NE', label: 'Nebraska' },
    { value: 'NV', label: 'Nevada' },
    { value: 'NH', label: 'New Hampshire' },
    { value: 'NJ', label: 'New Jersey' },
    { value: 'NM', label: 'New Mexico' },
    { value: 'NY', label: 'New York' },
    { value: 'NC', label: 'North Carolina' },
    { value: 'ND', label: 'North Dakota' },
    { value: 'OH', label: 'Ohio' },
    { value: 'OK', label: 'Oklahoma' },
    { value: 'OR', label: 'Oregon' },
    { value: 'PA', label: 'Pennsylvania' },
    { value: 'RI', label: 'Rhode Island' },
    { value: 'SC', label: 'South Carolina' },
    { value: 'SD', label: 'South Dakota' },
    { value: 'TN', label: 'Tennessee' },
    { value: 'TX', label: 'Texas' },
    { value: 'UT', label: 'Utah' },
    { value: 'VT', label: 'Vermont' },
    { value: 'VA', label: 'Virginia' },
    { value: 'WA', label: 'Washington' },
    { value: 'WV', label: 'West Virginia' },
    { value: 'WI', label: 'Wisconsin' },
    { value: 'WY', label: 'Wyoming' },
    { value: 'DC', label: 'District of Columbia' },
    { value: 'PR', label: 'Puerto Rico' },
    { value: 'GU', label: 'Guam' },
    { value: 'VI', label: 'U.S. Virgin Islands' },
    { value: 'AS', label: 'American Samoa' },
    { value: 'MP', label: 'Northern Mariana Islands' },
];
// Carriers supported for the "Shipping Tracking Number" identifier format.
export const SHIPPING_CARRIERS = [
    { value: 'UPS', label: 'UPS' },
    { value: 'FEDEX', label: 'FedEx' },
    { value: 'USPS', label: 'USPS' },
    { value: 'DHL_EXPRESS', label: 'DHL Express' },
    { value: 'AMAZON_LOGISTICS', label: 'Amazon Logistics' },
    { value: 'ONTRAC', label: 'OnTrac' },
];
export const getIndustryLabel = (value) =>
    INDUSTRIES.find(i => i.value === value)?.label ?? value;
export const getIdentifierLabel = (value) =>
    IDENTIFIER_FORMATS.find(f => f.value === value)?.label ?? value;